// frontend/src/features/campaign/data/blueprintTemplates.js

export const INSPIRATION_PROMPTS = [
  'SEA Enterprise Fintech & Banking Q4 Outbound',
  'B2B SaaS Lead Generation in Malaysia & Singapore',
  'Healthcare & MedTech Procurement Executive Outreach',
  'Logistics ERP & Supply Chain Decision-Makers',
];

export const BLUEPRINT_TEMPLATES = {
  'SEA Enterprise Fintech & Banking Q4 Outbound': {
    id: 'blueprint_fintech_q4',
    isTemplate: true,
    label: 'Fintech & Commercial Banking',
    name: 'SEA Enterprise Fintech & Banking Q4 Outbound',
    primaryObjective:
      'Accelerate Enterprise Demo Bookings & Net-New ARR Growth across Tier-1 Banks & Fintechs',
    campaignType: 'Customer Acquisition',
    industrySector: 'Fintech & Commercial Banking',
    targetRegion: 'Malaysia & Singapore',
    allocatedBudget: '$ 35,000',
    durationDays: 45,
    product: 'Enterprise AI Lead Gen & Pipeline Engine',
    productDescription:
      'Autonomous outbound revenue engine delivering verified banking decision-maker meetings with direct dials and multi-channel cadence.',
    targetPersonas: [
      'Vice President of Sales (VP Sales)',
      'Chief Revenue Officer (CRO)',
      'Head of Business Development',
      'Chief Executive Officer (CEO)',
    ],
    channels: ['Email', 'LinkedIn', 'Phone Call'],
    avgDealSize: 55000,
    audienceUniverse: 5200,
    geoMatchCount: 3800,
    industryMatchCount: 2400,
    personaMatchCount: 920,
    exclusionsCount: 140,
    finalAudienceCount: 780,
    priorityHigh: 290,
    priorityMed: 350,
    priorityLow: 140,
    positioning:
      'Transform commercial banking and fintech outbound pipelines into predictable revenue streams with 100% verified Malaysian and Singaporean executive direct dials.',
    painPoints:
      'Low outbound connect rates, manual SDR prospect research, stale CRM contact records, and strict regional financial regulatory hurdles.',
    matrix: [
      {
        persona: 'Vice President of Sales (VP Sales)',
        painPoint:
          'Sales reps waste 60% of their time prospecting outdated contact lists and hitting email bounce walls.',
        valueProp:
          '100% verified executive direct dials and automated cadence execution that double pipeline velocity in 30 days.',
        proofPoint:
          'Helped SEA digital bank scale enterprise pipeline by 3.8x with a 24% demo conversion rate.',
        cta: 'Book a 15-minute pipeline strategy walkthrough to review targeted banking accounts.',
        objection:
          'Already using LinkedIn Sales Nav -> We supply triple-verified direct phone numbers and automate omnichannel follow-ups with native CRM syncing.',
      },
      {
        persona: 'Chief Revenue Officer (CRO)',
        painPoint:
          'High customer acquisition costs (CAC) and unpredictable revenue forecasting across regional enterprise segments.',
        valueProp:
          'Predictable outbound pipeline engine with full visibility into rep activity, account engagement, and lead attribution.',
        proofPoint: 'Average 4.2x ROI delivered within the first 60 days of campaign deployment.',
        cta: 'Schedule an executive revenue consultation with our CRO team.',
        objection:
          'Concerned about brand reputation -> All outbound sequences strictly follow PDPA, Bank Negara, and MAS compliance governance rules.',
      },
      {
        persona: 'Head of Business Development',
        painPoint:
          'Struggling to secure high-ticket partnership discussions with enterprise financial institutions.',
        valueProp:
          'Multi-touch engagement sequences targeting verified financial executives across email, LinkedIn InMail, and phone.',
        proofPoint: 'Secured 32 Tier-1 commercial banking discovery meetings in under 6 weeks.',
        cta: 'Request our Fintech Outbound Playbook & Benchmark Report.',
        objection:
          'Outbound emails getting lost in spam -> Dedicated custom domain warmup with SPF, DKIM, and DMARC enforcement ensures 98%+ deliverability.',
      },
      {
        persona: 'Chief Executive Officer (CEO)',
        painPoint:
          'Slow time-to-market for enterprise solutions and heavy reliance on inbound referrals.',
        valueProp:
          'Turnkey autonomous pipeline generation unlocking new regional enterprise market share rapidly.',
        proofPoint:
          'Generated $ 1.4M in enterprise qualified pipeline across Malaysia and Singapore in Q3.',
        cta: 'Schedule a 20-minute executive briefing with our leadership.',
        objection:
          'No dedicated SDR headcount -> Our AI operates as your autonomous strategy assistant without expanding team overhead.',
      },
    ],
    journey: [
      {
        step: 1,
        day: 1,
        channel: 'Email',
        name: 'Executive Value Hook & Regional Fintech Intro',
        condition: 'Initial Touch',
      },
      {
        step: 2,
        day: 4,
        channel: 'LinkedIn',
        name: 'Connection Request & Peer Relevance Context',
        condition: 'If No Reply',
      },
      {
        step: 3,
        day: 8,
        channel: 'Email',
        name: 'Case Study: Tier-1 Bank Pipeline Acceleration',
        condition: 'If No Reply',
      },
      {
        step: 4,
        day: 14,
        channel: 'LinkedIn',
        name: 'Direct InMail with Exclusive Industry Benchmark',
        condition: 'If No Reply',
      },
      {
        step: 5,
        day: 21,
        channel: 'Phone Call',
        name: 'Warm Executive Phone Outreach (Direct Dial)',
        condition: 'If Email Opened',
      },
      {
        step: 6,
        day: 28,
        channel: 'Email',
        name: 'Final Strategy Briefing & Resource Deck',
        condition: 'If No Reply',
      },
    ],
    tasks: [
      {
        id: 'task_1',
        title: 'Verify Bank & Fintech C-Suite Contact Lists',
        assignee: 'AI Agent',
        status: 'Completed',
        dueDate: 'Day 2',
        budget: '$ 5,000',
      },
      {
        id: 'task_2',
        title: 'Configure Warmup & Dedicated Domain Authentication',
        assignee: 'Alex Wong',
        status: 'In Progress',
        dueDate: 'Day 5',
        budget: '$ 8,000',
      },
      {
        id: 'task_3',
        title: 'Execute Step 1 Multi-Channel Outreach Blast',
        assignee: 'Sarah Lim',
        status: 'To Do',
        dueDate: 'Day 8',
        budget: '$ 12,000',
      },
      {
        id: 'task_4',
        title: 'Weekly Executive Pipeline Review & Lead Handover',
        assignee: 'Sarah Lim',
        status: 'To Do',
        dueDate: 'Day 25',
        budget: '$ 10,000',
      },
    ],
    governance: {
      gates: ['brand_voice', 'commercial', 'compliance_deliverability', 'pdpa_privacy'],
      allGatesApproved: false,
    },
    kpiForecast: {
      audience: 780,
      openRate: '46.5%',
      replyRate: '15.2%',
      meetings: '28 - 38',
      pipeline: '$ 980,000',
    },
  },

  'B2B SaaS Lead Generation in Malaysia & Singapore': {
    id: 'blueprint_saas_my_sg',
    isTemplate: true,
    label: 'Enterprise SaaS',
    name: 'B2B SaaS Lead Generation in Malaysia & Singapore',
    primaryObjective:
      'Scale Mid-Market & Enterprise SaaS Demo Velocity with Verified Decision-Maker Direct Dials',
    campaignType: 'Customer Acquisition',
    industrySector: 'Enterprise SaaS',
    targetRegion: 'Malaysia & Singapore',
    allocatedBudget: '$ 25,000',
    durationDays: 45,
    product: 'Next-Gen AI Prospect Finder',
    productDescription:
      'High-precision B2B lead intelligence and outbound workflow engine tailored for Southeast Asian tech and commercial companies.',
    targetPersonas: [
      'Vice President of Sales (VP Sales)',
      'Head of Business Development',
      'Chief Technology Officer (CTO)',
      'Managing Director',
    ],
    channels: ['Email', 'LinkedIn', 'WhatsApp'],
    avgDealSize: 32000,
    audienceUniverse: 6400,
    geoMatchCount: 4600,
    industryMatchCount: 2900,
    personaMatchCount: 1100,
    exclusionsCount: 160,
    finalAudienceCount: 940,
    priorityHigh: 360,
    priorityMed: 420,
    priorityLow: 160,
    positioning:
      'Unlock high-intent B2B software buyers across Malaysia and Singapore through verified multi-channel outbound cadence.',
    painPoints:
      'High cost per lead on paid ads, low email open rates, and inaccurate LinkedIn title targeting.',
    matrix: [
      {
        persona: 'Vice President of Sales (VP Sales)',
        painPoint:
          'Pipeline dryness and long sales rep onboarding cycles causing missed quarterly targets.',
        valueProp:
          'Autonomous AI lead scoring and verified direct dials to ramp SDR meeting quotas in week one.',
        proofPoint: 'Boosted qualified demo volume by 180% for a regional HRTech SaaS provider.',
        cta: 'Schedule a 15-minute live pipeline demonstration.',
        objection:
          'We rely primarily on inbound marketing -> Inbound fluctuates; our outbound engine creates predictable ARR baseline.',
      },
      {
        persona: 'Head of Business Development',
        painPoint:
          'Manual prospect researching eats up SDR hours without guaranteed meeting bookings.',
        valueProp:
          'Turnkey prospect data matching specific tech stacks, company headcounts, and verified decision-maker emails.',
        proofPoint:
          'Achieved 16.8% reply rate across Klang Valley and Singapore software companies.',
        cta: 'Claim your complimentary 50-verified prospect sample list.',
        objection:
          'Our market is too niche -> Custom filtering pinpoints exact verticals and buyer personas seamlessly.',
      },
      {
        persona: 'Chief Technology Officer (CTO)',
        painPoint: 'Security and integration risks with third-party software tools.',
        valueProp:
          'Enterprise-grade encryption, seamless REST API integration with major CRMs, and zero data leakage.',
        proofPoint: 'SOC2 Type II aligned architecture with dedicated workspace data isolation.',
        cta: 'View our technical integration and security whitepaper.',
        objection:
          'Will this disrupt our existing CRM? -> Native two-way sync keeps Hubspot/Salesforce pristine without duplication.',
      },
      {
        persona: 'Managing Director',
        painPoint: 'Unpredictable CAC and high agency retainer fees with low ROI.',
        valueProp:
          'Pay-for-performance outbound infrastructure delivering tangible B2B sales pipeline.',
        proofPoint: 'Average $ 480,000 in generated pipeline value within 45 days.',
        cta: 'Book a 20-minute growth briefing with our regional director.',
        objection:
          'Already tried cold email agencies -> We combine AI hyper-personalization with multichannel verification for superior deliverability.',
      },
    ],
    journey: [
      {
        step: 1,
        day: 1,
        channel: 'Email',
        name: 'Personalized Problem Hook & Industry SaaS Insight',
        condition: 'Initial Touch',
      },
      {
        step: 2,
        day: 3,
        channel: 'LinkedIn',
        name: 'LinkedIn Connection Request & Shared Network Context',
        condition: 'If No Reply',
      },
      {
        step: 3,
        day: 7,
        channel: 'Email',
        name: 'Regional Case Study & ROI Calculator',
        condition: 'If No Reply',
      },
      {
        step: 4,
        day: 12,
        channel: 'WhatsApp',
        name: 'Quick WhatsApp Direct Follow-up with Resource Link',
        condition: 'If Email Opened',
      },
      {
        step: 5,
        day: 18,
        channel: 'LinkedIn',
        name: 'InMail Value Proposition & Demo Invitation',
        condition: 'If No Reply',
      },
      {
        step: 6,
        day: 25,
        channel: 'Email',
        name: 'Polite Break-up & Executive SaaS Benchmark Deck',
        condition: 'If No Reply',
      },
    ],
    tasks: [
      {
        id: 'task_saas_1',
        title: 'Filter & Verify SaaS Decision-Maker Audience',
        assignee: 'AI Agent',
        status: 'Completed',
        dueDate: 'Day 1',
        budget: '$ 4,000',
      },
      {
        id: 'task_saas_2',
        title: 'Setup Custom Subdomains & Email Warmup Protocols',
        assignee: 'Alex Wong',
        status: 'In Progress',
        dueDate: 'Day 4',
        budget: '$ 6,000',
      },
      {
        id: 'task_saas_3',
        title: 'Launch Stage 1 Outreach Across MY & SG',
        assignee: 'Sarah Lim',
        status: 'To Do',
        dueDate: 'Day 7',
        budget: '$ 8,000',
      },
      {
        id: 'task_saas_4',
        title: 'Pipeline Conversion & Demo Booking Handoff',
        assignee: 'Sarah Lim',
        status: 'To Do',
        dueDate: 'Day 20',
        budget: '$ 7,000',
      },
    ],
    governance: {
      gates: ['brand_voice', 'commercial', 'compliance_deliverability', 'pdpa_privacy'],
      allGatesApproved: false,
    },
    kpiForecast: {
      audience: 940,
      openRate: '48.2%',
      replyRate: '16.8%',
      meetings: '35 - 48',
      pipeline: '$ 750,000',
    },
  },

  'Healthcare & MedTech Procurement Executive Outreach': {
    id: 'blueprint_healthcare_medtech',
    isTemplate: true,
    label: 'Healthcare & MedTech',
    name: 'Healthcare & MedTech Procurement Executive Outreach',
    primaryObjective:
      'Establish Direct Dialogue with Hospital Procurement Directors & Clinical Decision-Makers',
    campaignType: 'Account-Based Marketing (ABM)',
    industrySector: 'Healthcare & MedTech',
    targetRegion: 'Malaysia & Singapore',
    allocatedBudget: '$ 40,000',
    durationDays: 60,
    product: 'HealthTech Provider Suite',
    productDescription:
      'Compliant medical procurement and clinical workflow automation platform engineered for private hospitals and healthcare networks.',
    targetPersonas: [
      'Operations Director / COO',
      'Chief Information Officer (CIO)',
      'Chief Financial Officer (CFO)',
      'Managing Director',
    ],
    channels: ['Email', 'LinkedIn', 'Phone Call'],
    avgDealSize: 85000,
    audienceUniverse: 3400,
    geoMatchCount: 2200,
    industryMatchCount: 1400,
    personaMatchCount: 560,
    exclusionsCount: 80,
    finalAudienceCount: 480,
    priorityHigh: 210,
    priorityMed: 190,
    priorityLow: 80,
    positioning:
      'Empower private healthcare systems with compliant procurement efficiency, reducing equipment lead times by 40%.',
    painPoints:
      'Stringent procurement compliance, fragmented vendor communications, long hospital evaluation committees, and strict data privacy regulations.',
    matrix: [
      {
        persona: 'Operations Director / COO',
        painPoint:
          'Supply chain bottlenecks and medical equipment procurement delays impacting hospital operations.',
        valueProp:
          'Unified clinical procurement management reducing purchasing cycle times and stockout risk.',
        proofPoint:
          'Deployed across 12 private hospital networks in Malaysia with 99.4% SLA adherence.',
        cta: 'Schedule an executive consultation on hospital procurement optimization.',
        objection:
          'Hospital procurement policies are very rigid -> We align with ISO 13485 and Malaysian Medical Device Authority (MDA) guidelines.',
      },
      {
        persona: 'Chief Information Officer (CIO)',
        painPoint:
          'Integrating medical devices and procurement data securely with hospital information systems (HIS).',
        valueProp:
          'HL7 and FHIR-compliant architecture ensuring seamless EHR and HIS interoperability.',
        proofPoint: 'Zero clinical downtime recorded across 50,000+ patient-facing transactions.',
        cta: 'Request our Healthcare Cybersecurity & Architecture Whitepaper.',
        objection:
          'Data security and patient privacy concerns -> Full end-to-end encryption compliant with PDPA and Malaysian Healthcare Data Protection standards.',
      },
      {
        persona: 'Chief Financial Officer (CFO)',
        painPoint:
          'Opaque vendor margins and escalating operating expenditures across hospital branches.',
        valueProp:
          'Real-time expenditure tracking and automated vendor contract benchmarking saving 15-22% in procurement costs.',
        proofPoint: 'Delivered $ 1.2M in annual cost savings for a regional hospital group.',
        cta: 'Request a customized Hospital Financial Impact & ROI Model.',
        objection:
          'High upfront capital expenditure -> We provide flexible OPEX models with rapid implementation timelines.',
      },
      {
        persona: 'Managing Director',
        painPoint:
          'Maintaining regional healthcare leadership while managing clinical quality and margin pressures.',
        valueProp:
          'Transform operational efficiency to deliver better patient outcomes and sustainable healthcare margins.',
        proofPoint:
          'Helped leading medical group win Healthcare Asia Operational Excellence Award.',
        cta: 'Book a private executive briefing with our healthcare practice lead.',
        objection:
          'Our clinical board requires lengthy approvals -> We provide turnkey pilot programs with zero operational disruption.',
      },
    ],
    journey: [
      {
        step: 1,
        day: 1,
        channel: 'Email',
        name: 'Hospital Procurement Efficiency Brief & Clinical Value Hook',
        condition: 'Initial Touch',
      },
      {
        step: 2,
        day: 5,
        channel: 'LinkedIn',
        name: 'LinkedIn Connection with Healthcare Operations Lead',
        condition: 'If No Reply',
      },
      {
        step: 3,
        day: 10,
        channel: 'Email',
        name: 'Private Hospital Group Case Study & Cost Benchmark',
        condition: 'If No Reply',
      },
      {
        step: 4,
        day: 18,
        channel: 'Phone Call',
        name: 'Executive Consultation Call with Hospital C-Suite Secretary',
        condition: 'If Email Opened',
      },
      {
        step: 5,
        day: 28,
        channel: 'LinkedIn',
        name: 'Direct InMail with Exclusive Healthcare Innovation Deck',
        condition: 'If No Reply',
      },
      {
        step: 6,
        day: 40,
        channel: 'Email',
        name: 'Formal Invitation to Private Healthcare Roundtable',
        condition: 'If No Reply',
      },
    ],
    tasks: [
      {
        id: 'task_med_1',
        title: 'Map Private Hospital & Clinic Procurement Committees',
        assignee: 'AI Agent',
        status: 'Completed',
        dueDate: 'Day 3',
        budget: '$ 6,000',
      },
      {
        id: 'task_med_2',
        title: 'Validate Compliance & Hospital Data Security Documentation',
        assignee: 'Alex Wong',
        status: 'In Progress',
        dueDate: 'Day 7',
        budget: '$ 10,000',
      },
      {
        id: 'task_med_3',
        title: 'Initiate Tier-1 Hospital Director Multichannel Sequence',
        assignee: 'Sarah Lim',
        status: 'To Do',
        dueDate: 'Day 12',
        budget: '$ 14,000',
      },
      {
        id: 'task_med_4',
        title: 'Executive Healthcare Roundtable Invitation Management',
        assignee: 'Sarah Lim',
        status: 'To Do',
        dueDate: 'Day 35',
        budget: '$ 10,000',
      },
    ],
    governance: {
      gates: ['brand_voice', 'commercial', 'compliance_deliverability', 'pdpa_privacy'],
      allGatesApproved: false,
    },
    kpiForecast: {
      audience: 480,
      openRate: '52.0%',
      replyRate: '18.4%',
      meetings: '18 - 26',
      pipeline: '$ 1,650,000',
    },
  },

  'Logistics ERP & Supply Chain Decision-Makers': {
    id: 'blueprint_logistics_erp',
    isTemplate: true,
    label: 'Logistics & Supply Chain',
    name: 'Logistics ERP & Supply Chain Decision-Makers',
    primaryObjective:
      'Engage 3PL, Freight & Warehouse Executives to Drive Digital ERP Transformation',
    campaignType: 'Customer Acquisition',
    industrySector: 'Logistics & Supply Chain',
    targetRegion: 'Malaysia (All States)',
    allocatedBudget: '$ 30,000',
    durationDays: 45,
    product: 'Supply Chain AI Intelligence',
    productDescription:
      'End-to-end freight, fleet, and warehouse ERP intelligence platform providing real-time cargo visibility and automated route optimization.',
    targetPersonas: [
      'Operations Director / COO',
      'Chief Information Officer (CIO)',
      'Chief Technology Officer (CTO)',
      'Chief Financial Officer (CFO)',
    ],
    channels: ['Email', 'LinkedIn', 'WhatsApp'],
    avgDealSize: 45000,
    audienceUniverse: 4800,
    geoMatchCount: 3600,
    industryMatchCount: 2200,
    personaMatchCount: 810,
    exclusionsCount: 110,
    finalAudienceCount: 700,
    priorityHigh: 260,
    priorityMed: 320,
    priorityLow: 120,
    positioning:
      'Empower logistics leaders across Port Klang, Penang, and Johor to eliminate shipment delays and slash fleet fuel costs by 18%.',
    painPoints:
      'Legacy ERP silos, manual customs dispatch paperwork, rising fuel/maintenance costs, and lack of real-time container tracking.',
    matrix: [
      {
        persona: 'Operations Director / COO',
        painPoint:
          'Dispatch delays, empty backhauls, and driver allocation chaos hurting delivery margins.',
        valueProp:
          'Automated AI dispatch and real-time fleet route optimization that increases asset utilization by 28%.',
        proofPoint:
          'Saved leading Malaysian 3PL over 1,400 dispatch hours monthly with 99.2% on-time delivery.',
        cta: 'Book a 15-minute logistics workflow assessment.',
        objection:
          'Our drivers are resistant to new tech -> Mobile-first intuitive driver app designed for WhatsApp-like simplicity.',
      },
      {
        persona: 'Chief Information Officer (CIO)',
        painPoint:
          'Disconnected legacy warehouse management (WMS) and transport systems (TMS) causing data inaccuracies.',
        valueProp:
          'Unified cloud ERP hub with open APIs connecting existing customs, weighing, and GPS hardware.',
        proofPoint: 'Completed multi-warehouse ERP integration in 21 days with zero downtime.',
        cta: 'Download our Logistics ERP Technical Architecture Guide.',
        objection:
          'Heavy integration burden -> Plug-and-play connectors for SAP, Oracle, and regional customs EDI.',
      },
      {
        persona: 'Chief Financial Officer (CFO)',
        painPoint:
          'Uncontrolled demurrage fees, unbilled transport surcharges, and rising logistics operating overheads.',
        valueProp:
          'Automated billing reconciliation and fuel anomaly detection yielding instant OPEX reduction.',
        proofPoint:
          'Identified $ 320,000 in unbilled accessorial charges for a regional freight forwarder.',
        cta: 'Request an ROI & Fleet Cost Reduction Simulation.',
        objection:
          'ROI timeline is too slow -> Customers typically realize full payback within 4.5 months.',
      },
      {
        persona: 'Chief Technology Officer (CTO)',
        painPoint:
          'Lack of real-time IoT telematics ingestion and predictive maintenance alerting.',
        valueProp:
          'Real-time telemetry engine providing predictive engine diagnostics and GPS geo-fencing.',
        proofPoint: 'Reduced unplanned fleet breakdowns by 34% across 450 prime movers.',
        cta: 'Schedule an IoT & Telematics Platform Demo.',
        objection:
          'Concerned about hardware compatibility -> Compatible with standard OBD-II and all major telematics providers.',
      },
    ],
    journey: [
      {
        step: 1,
        day: 1,
        channel: 'Email',
        name: 'Supply Chain Bottleneck Analysis & Efficiency Value Hook',
        condition: 'Initial Touch',
      },
      {
        step: 2,
        day: 4,
        channel: 'LinkedIn',
        name: 'LinkedIn Connection Request with Logistics Practice Lead',
        condition: 'If No Reply',
      },
      {
        step: 3,
        day: 8,
        channel: 'Email',
        name: '3PL Port Klang Case Study & Fleet Cost Benchmark',
        condition: 'If No Reply',
      },
      {
        step: 4,
        day: 14,
        channel: 'WhatsApp',
        name: 'Quick WhatsApp Direct Note with Fleet Calculator Link',
        condition: 'If Email Opened',
      },
      {
        step: 5,
        day: 20,
        channel: 'LinkedIn',
        name: 'Direct InMail Offering Free ERP Assessment',
        condition: 'If No Reply',
      },
      {
        step: 6,
        day: 28,
        channel: 'Email',
        name: 'Final Executive Logistics Optimization Deck',
        condition: 'If No Reply',
      },
    ],
    tasks: [
      {
        id: 'task_log_1',
        title: 'Extract & Verify 3PL and Freight Forwarder C-Level Contacts',
        assignee: 'AI Agent',
        status: 'Completed',
        dueDate: 'Day 2',
        budget: '$ 5,000',
      },
      {
        id: 'task_log_2',
        title: 'Configure Multichannel Sender Domains & WhatsApp Templates',
        assignee: 'Alex Wong',
        status: 'In Progress',
        dueDate: 'Day 5',
        budget: '$ 7,000',
      },
      {
        id: 'task_log_3',
        title: 'Initiate Port & Transport Executive Outreach Cadence',
        assignee: 'Sarah Lim',
        status: 'To Do',
        dueDate: 'Day 9',
        budget: '$ 10,000',
      },
      {
        id: 'task_log_4',
        title: 'Lead Follow-up & ERP Live Walkthrough Handover',
        assignee: 'Sarah Lim',
        status: 'To Do',
        dueDate: 'Day 24',
        budget: '$ 8,000',
      },
    ],
    governance: {
      gates: ['brand_voice', 'commercial', 'compliance_deliverability', 'pdpa_privacy'],
      allGatesApproved: false,
    },
    kpiForecast: {
      audience: 700,
      openRate: '44.8%',
      replyRate: '14.9%',
      meetings: '24 - 34',
      pipeline: '$ 890,000',
    },
  },
};

/**
 * Helper to retrieve a template by exact or partial prompt match.
 * Returns null if no template matches.
 */
export function getBlueprintTemplateByPrompt(prompt) {
  if (!prompt || typeof prompt !== 'string') return null;
  const trimmed = prompt.trim();
  let matched = null;

  // Exact match
  if (BLUEPRINT_TEMPLATES[trimmed]) {
    matched = BLUEPRINT_TEMPLATES[trimmed];
  } else {
    // Exact Case-insensitive match
    const lower = trimmed.toLowerCase();
    for (const key of Object.keys(BLUEPRINT_TEMPLATES)) {
      if (key.toLowerCase() === lower) {
        matched = BLUEPRINT_TEMPLATES[key];
        break;
      }
    }
  }

  if (!matched) return null;

  const result = JSON.parse(JSON.stringify(matched));
  const today = new Date();
  const y = today.getFullYear();
  const m = String(today.getMonth() + 1).padStart(2, '0');
  const d = String(today.getDate()).padStart(2, '0');
  result.startDate = `${y}-${m}-${d}`;

  const dur = parseInt(result.durationDays, 10) || 45;
  const end = new Date(today);
  end.setDate(end.getDate() + dur);
  const ey = end.getFullYear();
  const em = String(end.getMonth() + 1).padStart(2, '0');
  const ed = String(end.getDate()).padStart(2, '0');
  result.endDate = `${ey}-${em}-${ed}`;

  return result;
}
